export const getValue = function (item) {
  return typeof item === 'object' ? item.value : item
}

export const getKey = function (item) {
  return typeof item === 'object' ? item.key : item
}



// WEBPACK FOOTER //
// ./~/.0.1.3@vux/src/components/checklist/object-filter.js